import AntDatePicker from 'antd-core/es/date-picker';
import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';
import { ChevronLeft } from '../../icons/ChevronLeft/ChevronLeft.js';
import { ChevronRight } from '../../icons/ChevronRight/ChevronRight.js';
import { withInjectedClassName } from '../../hocs/withInjectedClassName/withInjectedClassName.js';
import { datePickerCss } from '../../styling/css/datePicker.js';

const Root = styled(withInjectedClassName(AntDatePicker.RangePicker, 'popupClassName')) `
  ${datePickerCss};

  &.tend-ui-picker-dropdown
    .tend-ui-picker-cell-in-view.tend-ui-picker-cell-range-start:not(
      .tend-ui-picker-cell-range-start-single
    ):not(.tend-ui-picker-cell-range-end)
    .tend-ui-picker-cell-inner {
    border-start-end-radius: 8px;
    border-end-end-radius: 8px;
  }

  &.tend-ui-picker-dropdown
    .tend-ui-picker-cell-in-view.tend-ui-picker-cell-range-end:not(
      .tend-ui-picker-cell-range-end-single
    ):not(.tend-ui-picker-cell-range-start)
    .tend-ui-picker-cell-inner {
    border-start-start-radius: 8px;
    border-end-start-radius: 8px;
  }
`;
const PrevIcon = styled(ChevronLeft) `
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.gray50};
  transition: all 0.3s;
  &:hover:not(:active) {
    border-color: ${colors.blue600};
  }
  &:active {
    background-color: ${colors.blue100};
  }
`;
const NextIcon = styled(ChevronRight) `
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.gray50};
  transition: all 0.3s;
  &:hover:not(:active) {
    border-color: ${colors.blue600};
  }
  &:active {
    background-color: ${colors.blue100};
  }
`;

export { NextIcon, PrevIcon, Root };
//# sourceMappingURL=styled.js.map
